module.exports = __webpack_public_path__ + "77c94365e2d14bc74d888a1f750e6957.png";